import {h, Fragment, Component} from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

import PFeed from "../../../services/prematch-feed";
import Page from "../../../services/page-data-feed";

import * as M from "../desktop-templates/prematch-menu.jsx";

import SchedulesTimeFilter from "../utils/schedules-time-filter.jsx"


export class MenuSportsOnly extends Component {
	state = {
		sports: null,
		expanded: false
	}
	componentWillMount() {
		PFeed.getMenu((label, menu) => {
			this.setState({
				sports: Object.values(menu).sort((a, b) => a.order - b.order)
			})
		})
	}
	render() {
		if (this.state.sports == null)
			return null;
		const maxEvents = !this.state.expanded ? 10 : this.state.sports.length;
		return <div>
			{this.state.sports.filter(s => SchedulesTimeFilter.isEventAllowed(s)).slice(0, maxEvents).map(sport => (
				<SportRow 
					sport={sport} 
					active={false} 
					onClick={console.log} />
			))}
			<M.SportButton onClick={() => this.setState({expanded: !this.state.expanded})}>
				{!this.state.expanded 
					? <M.MenuTitleCenteredLabel><Trans>Show More</Trans></M.MenuTitleCenteredLabel>
					: <M.MenuTitleCenteredLabel><Trans>Show Less</Trans></M.MenuTitleCenteredLabel>}
			</M.SportButton>
		</div>
	}
}

export class SportRow extends Component {
	render({sport}) {
		return <div>
			<M.SportButton active={this.props.active} onClick={() => this.props.onClick(sport)}>
			  <M.MenuMatchCounter>{sport.count}</M.MenuMatchCounter>
			  <M.CircleSeparator />
			  <M.LeagueNameLabel>{sport.name}</M.LeagueNameLabel>
			  <M.SportFlagIcon sport={sport} />
			</M.SportButton>
		  </div>
	}
}
